import { formLogout } from '@/services';

export function handleUserIdle() {
  // Clear all storages
  localStorage.clear();
  sessionStorage.clear();

  // Explicitly remove specific keys if needed (extra safety)
  const itemsToRemove = [
    'user',
    'token',
    'authToken',
    'refreshToken',
    'userSession',
    'loginState',
    'redirectedFromRegistration'
  ];

  itemsToRemove.forEach((item) => {
    localStorage.removeItem(item);
    sessionStorage.removeItem(item);
  });

  // Perform logout, then redirect
  formLogout()
    .then(() => (window.location.href = `${window.location.origin}/inloggen`))
    .catch((error) => {
      console.error('Logout error:', error);
      window.localStorage.setItem('activeMyTodoToggle', false);
      window.location.href = `${window.location.origin}/inloggen`;
    });
}
